import React from 'react';

import { Typography } from '@material-ui/core';

function AuthBodyTitle ({ ...otherProps }) {
    return (
        <Typography
            variant="h2"
            color="primary"
            {...otherProps}
        />
    );
}

export default AuthBodyTitle;